import React from 'react';
import PropTypes from 'prop-types';
import { SilentDialog } from '@src/components/SilentDialog';
import FrCheckBlueSvg from '@src/svgs/fr-check-blue.svg';

export const BenefitsList = ({ benefits }) => {
  if (!benefits.length) {
    return null;
  }

  return benefits.map((text, i) => (
    <SilentDialog className="subscription-modal__dialog-item" icon={FrCheckBlueSvg} key={i} text={text} />
  ));
};

BenefitsList.propTypes = {
  benefits: PropTypes.arrayOf(PropTypes.string).isRequired,
};
